import { useState } from "react";
import { connect, useDispatch } from "react-redux";
import LedgerIcon from "../../../assets/svg/ledger.svg";
import VanIcon from "../../../assets/svg/van.svg";
import ResizeListener from "../../../utility/ResizeListener";
import BodyComponent from "../../components/BodyComponent";
import SidebarLayout from "../../components/SidebarLayout";
import {
  BeneficiaryManagment,
  CustomerManagement,
  PayOut,
} from "../../resources/assetsManager";
import {
  BENEFICIARY_TAB,
  CUSTOMERS_TAB,
  GENERATED_REPORTS,
  LEDGER_TAB,
  PAY_IN,
  PAY_OUT,
  PREFUND_HISTORY,
  SCHEDULERS,
} from "../../resources/constantsManager";
import FundTransfer from "./fundTransfer";
import PrefundHistory from "./prefund";
import GReport from "../../../assets/svg/g_report.svg";
import ScheduleClock from "../../../assets/svg/schedule_clock.svg";

import { setCurrentTabAction } from "../../../data/redux/action/currentTabAction";
import Ledger from "../financeCenter/ledger";
import Van from "./van";
import BeneficiaryIndex from "../customerCenter/beneficiary/BeneficiaryIndex";
import Customers from "../customerCenter/Customers";
import GeneratedReports from "../reportCenter/generatedReports";
import Schedulers from "../reportCenter/schedulers";
const TransactionCenter = ({ profileDetails, currentTabFromRedux }) => {
  const [currentTab, setCurrentTab] = useState(currentTabFromRedux);
  const { height } = ResizeListener();
  const [filterOpened, setFilterOpened] = useState(false);

  const TransactionMenu = [
    {
      toHeading: 1,
      headerName: "Transactions",
    },

    {
      name: "Pay In",
      icon: VanIcon,
      key: PAY_IN,
      toHeading: 1,
    },
    {
      name: "Pay Out",
      icon: PayOut,
      key: PAY_OUT,
    },
    {
      name: "Prefund",
      icon: VanIcon,
      key: PREFUND_HISTORY,
    },
    // {
    //   toHeading: 2,
    //   headerName: "Finance",
    // },

    {
      toHeading: 2,
      headerName: "Finance",
    },
    {
      name: "Ledger",
      icon: LedgerIcon,
      key: LEDGER_TAB,
      toHeading: 2,
    },
    {
      toHeading: 3,
      headerName: "Customer Management",
    },

    {
      name: "Beneficiary",
      key: BENEFICIARY_TAB,
      icon: BeneficiaryManagment,
      toHeading: 3,
    },
    {
      name: "Customer",
      icon: CustomerManagement,
      key: CUSTOMERS_TAB,
    },
    {
      toHeading: 4,
      headerName: "Reports",
    },

    {
      name: "Generated Reports",
      icon: GReport,
      key: GENERATED_REPORTS,
      toHeading: 4,
    },
    {
      name: "Schedulers",
      icon: ScheduleClock,
      key: SCHEDULERS,
    },
  ];
  const TransactionMenu2 = [
    {
      name: "Pay In",
      icon: VanIcon,
      key: PAY_IN,
    },
  ];
  const dispatch = useDispatch();

  return (
    <>
      <SidebarLayout
        //profileDetails?.payOutStatus
        menu={profileDetails?.payOutStatus ? TransactionMenu : TransactionMenu2}
        passCurrentTab={(tab) => {
          setCurrentTab(tab);
          dispatch(setCurrentTabAction(tab));
        }}
        activeTab={currentTab}
      />
      <BodyComponent
        style={{
          height: filterOpened ? height : height * 0.85,
          transition: "height 0.5s ease-out",
          overflow: "hidden",
          height: height * 0.3,
        }}
      >
        {currentTab === PAY_IN ? (
          <Van filterOpened={(data) => setFilterOpened(data)} />
        ) : currentTab === PREFUND_HISTORY ? (
          <PrefundHistory />
        ) : currentTab === LEDGER_TAB ? (
          <Ledger
            filterOpened={(data) => {
              setFilterOpened(data);
            }}
          />
        ) : currentTab === PAY_OUT ? (
          <FundTransfer />
        ) : currentTab === BENEFICIARY_TAB ? (
          <BeneficiaryIndex />
        ) : currentTab === CUSTOMERS_TAB ? (
          <Customers />
        ) : currentTab === GENERATED_REPORTS ? (
          <GeneratedReports />
        ) : currentTab === SCHEDULERS ? (
          <Schedulers />
        ) : null}
      </BodyComponent>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    profileDetails: state.profileDetailsReducer.details,
    currentTabFromRedux: state.currentTabReducer.currentTab,
  };
};

export default connect(mapStateToProps)(TransactionCenter);
